import * as React from 'react';
import { Route, RouteProps } from 'react-router-dom';
import { ROLE } from '../../config/Role';

interface PrivateRouteProps extends RouteProps {
    // render: (() => ReactComponentElement<any>) | undefined;
    authorizedRoles?: Array<ROLE>;
    path: string;
    invert?: boolean;
    redirectTo?: string;
}

export function PublicRoute({
    // render,
    redirectTo = '/login',
    invert,
    authorizedRoles,
    path,
    children,
    ...rest
}: PrivateRouteProps) {

    return <Route {...rest} path={path} children={children} />;
}
